// import { React } from "react";
import FaceRegister from "../../../faceRecognition/FaceRegister";
// import { useAuthContext } from "../../../firebase-files/hooks/useAuthContext";
import { useParams } from "react-router-dom";
// import { useCollection } from "../../../firebase-files/hooks/useCollection";
import { useDocument } from "../../../firebase-files/hooks/useDocument";

const UserDetailsFaceRegistration = () => {
  // const { user } = useAuthContext();
  const { userProfileId } = useParams();

  const { document: userDoc, error } = useDocument("users", userProfileId);

  return (
    <div className="pd-cards animate-slide-in">
      <div className="pd-heading">
        <h2>Face Registration</h2>
      </div>

      <div className="pd-roles">
        <div className="row d-flex justify-content-around align-items-center">
          <div className="face-register-card-img-div col-12 col-md-6">
            {(userDoc && !userDoc.registeredFaceUrl) ||
            (userDoc && userDoc.registeredFaceUrl == "") ? (
              <>
                <img
                  src="/assets/img/face-scanner.gif"
                  alt="user registerd face"
                />
              </>
            ) : (
              <>
                <img
                  src={userDoc && userDoc.registeredFaceUrl}
                  alt="user registerd face"
                />
              </>
            )}
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center flex-column btn_heading_face_registr">
            {userDoc?.faceRegistration?.length > 0 &&
            userDoc?.faceRegistration?.[0]?.createdAt ? (
              <section>
                <p>Last Registered At :</p>
                <p>
                  {userDoc.faceRegistration[0].createdAt
                    .toDate()
                    .toLocaleString("en-GB", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                </p>
              </section>
            ) : (
              <p>No Face Registered Yet!</p>
            )}
            <FaceRegister />
          </div>
        </div>
        &nbsp;
      </div>
    </div>
  );
};

export default UserDetailsFaceRegistration;
